import React, { useEffect, useState, useContext } from 'react';
import { StorefrontContext } from '../store/StorefrontContext.jsx';
import { ProductCoilSettingContext } from '../store/ProductCoilSettingContext.jsx';
import { Container } from 'react-bootstrap';
import { updateMetaObjectCoilSetting } from '../api/adminApi.jsx';
import { size } from 'lodash';
import { getInventoryItemByVariantId, setOnHandQuantitiesOfProduct } from '../api/adminApi.jsx';
import * as Sentry from '@sentry/react';

const ProductCoilSetting = () => {
    const [coilSettings, setCoilSettings] = useState([]);
    const [id, setId] = useState('');
    const [count, setCount] = useState('');
    const [coilSize, setCoilSize] = useState('');
    const [productId, setProductId] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [productSummary, setProductSummary] = useState('');
    const { state: storefrontStateObject, fetchMetaObject } = useContext(StorefrontContext);
    const { productCoilSetting, updateProductCoilSetting } = useContext(ProductCoilSettingContext);
    const products = storefrontStateObject?.products;

    // useEffect(() => {
    //     const savedSettings = JSON.parse(localStorage.getItem('coilSettings'));
    //     if (savedSettings) {
    //         console.log('savedSettings', savedSettings);
    //         setCoilSettings(savedSettings);
    //     }
    // }, []);

    useEffect(() => {
        setCoilSettings(productCoilSetting);
    }, [productCoilSetting]);

    useEffect(() => {
        createProductCountSummary();
    }, [coilSettings]);        

    const createProductCountSummary = () => {
        console.log('createProductCountSummary products', products);
        products?.forEach((product) => {
            const count = coilSettings.filter((setting) => setting.productId === product.id)?.map((setting) => setting.count).reduce((a, b) => a + b, 0);
            setProductSummary((prevSummary) => ({
                ...prevSummary,
                [product.id]: count,
            }));
        });
    };
    const getProductTotalCount = (productId) => {
        return coilSettings.filter((setting) => setting.productId === productId)?.map((setting) => setting.count).reduce((a, b) => a + b, 0);
    };

    const handleAddSetting = () => {
        const newSetting = {
            id: id,
            count: parseInt(count),
            coilSize: parseInt(coilSize),
            productId: productId,
            expiryDate: expiryDate,
        };

        const currentTotalCount = getProductTotalCount(productId);
        updateInventoryQuantityOnShopify(productId, currentTotalCount + newSetting.count);

        const updatedSettings = [...coilSettings, newSetting];
        setCoilSettings(updatedSettings);
        // localStorage.setItem('coilSettings', JSON.stringify(updatedSettings));
        // updateMetaObjectCoilSetting(updatedSettings);
        updateProductCoilSetting(updatedSettings);
        setId('');
        setProductId('');
        setCount('');
        setCoilSize('');
        setExpiryDate('')
    };

    const handleEditSetting = (index) => {
        const setting = coilSettings[index];
        setId(setting.id);
        setProductId(setting.productId);
        setCount(setting.count);
        setCoilSize(setting.coilSize);
        setExpiryDate(setting.expiryDate);
        handleDeleteSetting(index);
    };

    const handleDeleteSetting = (index) => {
        const productId = coilSettings[index].productId;
        const count = coilSettings[index].count;
        const currentTotalCount = getProductTotalCount(productId);
        updateInventoryQuantityOnShopify(productId, currentTotalCount - count);
        const updatedSettings = coilSettings.filter((_, i) => i !== index);
        setCoilSettings(updatedSettings);
        // localStorage.setItem('coilSettings', JSON.stringify(updatedSettings));
        // updateMetaObjectCoilSetting(updatedSettings);
        updateProductCoilSetting(updatedSettings);
    };

    const updateInventoryQuantityOnShopify = (productId, updatedCount) => {
        getInventoryItemByVariantId(productId).then((inventoryItem) => {
            console.log('productId', productId, 'inventoryItem', inventoryItem, 'updatedCount', updatedCount);
            const inventoryItemId = inventoryItem.data.productVariant.inventoryItem.id;
            const locationId = localStorage.getItem('locationId');
            setOnHandQuantitiesOfProduct(locationId, inventoryItemId, updatedCount);
        });
    }

    return (
        <Container
            fluid={true}
            style={{
                fontSize: '1.5rem',
            }}
        >
            <div>
                <h1>Product Coil Settings</h1>
                <div>
                    <label>
                        ID:
                        <input
                            type="number"
                            value={id}
                            onChange={(e) => setId(e.target.value)}
                            disabled={!!coilSettings.id}
                        />
                    </label>
                </div>
                <div>
                    <label>
                        Product:
                        <select value={productId} onChange={(e) => setProductId(e.target.value)}>
                            <option value="">Select a product</option>
                            {products?.map((product) => (
                                <option key={product.id} value={product.id}>
                                    {product.title}
                                </option>
                            ))}
                        </select>
                    </label>
                </div>
                <div>
                    <label>
                        Count:
                        <input
                            type="number"
                            value={count}
                            onChange={(e) => setCount(e.target.value)}
                        />
                    </label>
                </div>
                <div>
                    <label>
                        Coil Size:
                        <input
                            type="number"
                            value={coilSize}
                            onChange={(e) => setCoilSize(e.target.value)}
                        />
                    </label>
                </div>
                <div>
                    <label>
                        Expiry Date:
                        <input
                            type="date"
                            value={expiryDate}
                            onChange={(e) => setExpiryDate(e.target.value)}
                        />
                    </label>
                </div>
            </div>
            <div>
                <button onClick={handleAddSetting}>Add Setting</button>
                <h2>Current Summary</h2>
                <ul>
                    {Object.entries(productSummary)?.map(([productId, count]) => (
                        <li key={productId}>
                            {products?.find((product) => product.id === productId)?.title || 'N/A'}: {count}
                        </li>
                    ))}
                </ul>
                <h2>Current Settings</h2>
                <ul>
                    {coilSettings?.map((setting, index) => (
                        <li key={index}>
                            {/* ID: {setting.id}, Product: {setting.productId} Count: {setting.count}, Coil Size: {setting.coilSize} */}
                            {/* show id, product name, and count */}
                            ID: {setting.id}, <br />
                            Product: {products?.find((product) => product.id === setting.productId)?.title || 'N/A'}({setting.productId}), <br />
                            Count: {setting.count}, <br />
                            Coil Size: {setting.coilSize}<br />
                            Expiry Date: {setting.expiryDate}<br />
                            <button onClick={() => handleEditSetting(index)}>Edit</button>
                            <button onClick={() => handleDeleteSetting(index)}>Delete</button>
                        </li>
                    ))}
                </ul>
            </div>
        </Container>
    );
};

export default Sentry.withProfiler(ProductCoilSetting);